'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _videoAsset = require('@spp/video-asset');

var _videoAsset2 = _interopRequireDefault(_videoAsset);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSquare = function isSquare() {
    var asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var height = (0, _get3.default)(asset, 'sourceFiles[0].height');
    var width = (0, _get3.default)(asset, 'sourceFiles[0].width');
    return height && width && height === width;
};

var isAudio = function isAudio() {
    var asset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var height = (0, _get3.default)(asset, 'sourceFiles[0].height');
    var width = (0, _get3.default)(asset, 'sourceFiles[0].width');
    return height === 0 && width === 0;
};

var InlineVideo = function InlineVideo(_ref) {
    var _classNames;

    var theme = _ref.theme,
        render = _ref.render,
        props = (0, _objectWithoutProperties3.default)(_ref, ['theme', 'render']);

    var ratioClasses = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.videoRatio, true), (0, _defineProperty3.default)(_classNames, theme.square, isSquare(props.videoAsset)), (0, _defineProperty3.default)(_classNames, theme.audio, isAudio(props.videoAsset)), _classNames));

    return _react2.default.createElement(
        'div',
        { className: theme.root },
        _react2.default.createElement(
            'div',
            { className: ratioClasses },
            render(props)
        )
    );
};

InlineVideo.propTypes = {
    videoAsset: _irisPropTypes.objects.videoAsset.isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        videoRatio: _propTypes2.default.string,
        square: _propTypes2.default.string
    }),
    render: _propTypes2.default.func
};

InlineVideo.defaultProps = {
    theme: {},
    render: function render(props) {
        return _react2.default.createElement(_videoAsset2.default, props);
    }
};

exports.default = InlineVideo;
//# sourceMappingURL=InlineVideo.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/inline-video/lib/cjs/InlineVideo.js
 ** module id = 540
 ** module chunks = 1
 **/